import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import Button from '../../../../component/Button';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import UserInformation from './UserInformation';
import PersonalInformation from './PersonalInformation';
import DealersTable from './DealersTable';
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal';
import SuccessModal from '../../../../modalComponents/SuccessModal';
import ReasonModal from '../../../../modalComponents/ReasonModal';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { UserRoleID } from '../../../../helpers';
import AuthorizedUser from './AuthorizedUser';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import AddTarget from '../../../../modalComponents/AddTarget';
import EditUserModal from '../../../../modalComponents/EditUserModal';
import { Icons, Images } from '../../../../assets';
import ModalDropdown from '../../../../component/ModalDropdown';
import CloseIcon from '@mui/icons-material/Close';
import InputBox from '../../../../component/InputBox';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import SearchableSelect from '../../../../component/SearchSelect';


const UserDetails = (props) => {
    const { viewData, userId, currentTab } = props
    const [showVerifyPopUp, setShowVerifyPopUp] = useState(false)
    const [showDeclinePopUp, setShowDeclinePopUp] = useState(false)
    const [showReasonPopUp, setShowReasonPopUp] = useState(false)
    const [showTargetPopUP, setShowTargetPopUp] = useState(false)
    const [editResource, setEditResource] = useState(false)
    const [showRejectModal, setShowRejectModal] = useState(false)
    const [userInfo, setUserInfo] = useState(null)
    const [isEdit, setIsEdit] = useState(false);
    const [isSalesManagerModal, setIsSalesManagerModal] = useState(false)
    const [salesManagers, setSalesManagers] = useState([]);
    const [salesManagerAction, setSalesManagerAction] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const activeTab = currentTab
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const location = useLocation()
    const rejectForm = useForm();
    const {
        register: rejectRegister,
        handleSubmit: rejectHandleSubmit,
        formState: { errors: rejectErrors },
    } = rejectForm;
    const salesManagerForm = useForm();
    const { handleSubmit: handleVerifySubmit, control: salesManagerControl, reset: resetSalesManagerForm, formState: { errors } } = salesManagerForm;


    const onRejectSubmit = (data) => {
        handleReject(data.reason);
    };
    useEffect(() => {
        getUserDetails()
        const timer = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
        return () => clearTimeout(timer);
    }, [])

    const getUserId = () => {
        const pathName = location?.search?.split("?id=");
        const params = pathName?.length > 1 ? pathName[pathName?.length - 1] : null;
        return params;
    };

    const getUserDetails = async () => {
        let url = `${Exported.Endpoints.getUserDetails}`
        let paramsObj = {
            user_id: userId,
            // user_role: UserRoleID[viewData?.userRole],
        }
        // if (viewData?.userRole == 'AuthorizedUser') {
        //     paramsObj['retailer_id'] = 2
        // }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                setUserInfo(res?.data?.data)
            } else {
                setUserInfo(null)
            }
        }).catch((err) => {
            console.log(err, "err")
            setUserInfo(null)
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const handleVerify = async (manager) => {
        dispatch(saveLoadingState(true));

        try {
            const paramsObj = {
                userId,
                sales_manager_id: manager.value,
                sales_manager_name: manager.label,
                reason: '',
                isVerified: true
            };

            const res = await request({
                url: Exported.Endpoints.updateRetailStatus,
                method: Exported.APIMethods.POST,
                data: paramsObj
            });

            if (res?.data?.status) {
                await getUserDetails();
                setShowVerifyPopUp(true);
            } else {
                Toast({ type: 'error', message: res?.data?.message || 'Verification failed' });
            }
        } catch (err) {
            Toast({
                type: 'error',
                message: err?.response?.data?.message || 'Unable to process the request!..'
            });
        } finally {
            dispatch(saveLoadingState(false));
            setIsSalesManagerModal(false);
        }
    };




    const getSalesManagers = async () => {
        dispatch(saveLoadingState(true));
        try {
            const res = await request({
                url: `${Exported.Endpoints.salesManagerList}?page=1&limit=10000`,
            });

            if (res?.data?.status) {
                const list = res?.data?.data?.data || [];

                setSalesManagers(
                    list
                        .filter(item => !item.is_deleted)
                        .map(item => ({
                            label: item.name,
                            value: item.id,
                        }))
                );
            }
        } catch (err) {
            Toast({
                type: 'error',
                message: 'Unable to fetch sales managers',
            });
        } finally {
            dispatch(saveLoadingState(false));
        }
    };


    const verifyOpenModal = () => {
        getSalesManagers();
        resetSalesManagerForm();
        setSalesManagerAction("VERIFY_RETAILER");
        setIsSalesManagerModal(true);
    };

    const approveOpenModal = () => {
        getSalesManagers();
        resetSalesManagerForm();
        setSalesManagerAction("APPROVE_MECHANIC");
        setIsSalesManagerModal(true);
    };

    const handleSalesManagerSubmit = async (data) => {
        const manager = data.salesManager;

        if (salesManagerAction === "VERIFY_RETAILER") {
            await handleVerify(manager);
        }

        if (salesManagerAction === "APPROVE_MECHANIC") {
            await handleApprove(true, manager);
            setIsSalesManagerModal(false);
        }
    };






    const handleApprove = async (status, manager) => {
        let url = `${Exported.Endpoints.approveMech}/${userId}`;
        dispatch(saveLoadingState(true));
        try {
            const response = await request({
                url,
                method: Exported.APIMethods.PUT,
                data: {
                    status,
                    sales_manager_id: manager?.value,
                    sales_manager_name: manager?.label,
                },
                params: { status }
            });

            if (response?.data?.status) {
                Toast({
                    type: 'success',
                    message: `User successfully ${status ? 'Approved' : 'Rejected'}`
                });
                getUserDetails();
            } else {
                Toast({
                    type: 'error',
                    message: response?.data?.message || 'Failed to update status'
                });
            }
        } catch (error) {
            Toast({
                type: 'error',
                message: error?.response?.data?.message || 'Unable to process the request!..'
            });
        } finally {
            dispatch(saveLoadingState(false));
        }
    };


    const redirectBack = () => {
        navigate('/admin/users')
    }

    const handleClose = () => {
        setShowDeclinePopUp(false)
    }

    const handleReasonClose = () => {
        setShowReasonPopUp(false)
    }

    const handleVerifyClose = () => {
        setShowVerifyPopUp(false)
        handleTarget()
    }

    const declineUser = () => {
        setShowDeclinePopUp(false)
        setShowReasonPopUp(true)
    }

    const handleTarget = () => {
        setShowTargetPopUp(true)
    }

    const closeTargetModal = () => {
        setShowTargetPopUp(false)
    }

    const handleSetTargetSuccess = () => {
        setShowTargetPopUp(false)
        navigate('/admin/users')
    }

    const handleEditModal = () => {
        setEditResource(true)
    }

    const handleCloseEditModal = () => {
        setEditResource(false)
    }

    const handleReject = async (reason) => {
        const url = `${Exported.Endpoints.approveMech}/${userId}`;
        dispatch(saveLoadingState(true));
        try {
            const response = await request({
                url: url,
                method: Exported.APIMethods.PUT,
                data: {
                    status: false,
                    reason: reason
                },
                params: { status: false },
            });

            if (response?.data?.status) {
                Toast({
                    type: 'success',
                    message: 'User successfully Rejected',
                });
                getUserDetails();
                setShowRejectModal(false);
            } else {
                Toast({
                    type: 'error',
                    message: response?.data?.message || 'Failed to reject user',
                });
            }
        } catch (error) {
            console.error(error);
            Toast({
                type: 'error',
                message: 'Unable to process the request!..',
            });
        } finally {
            dispatch(saveLoadingState(false));
        }
    };


    return (
        <>
            <div className={`${classes.userInfoWrapper}`}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title flex items-center`}>
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                        </div>
                        <div>User Details</div>
                    </div>
                    <div>
                        {
                            userInfo?.user?.approvedByAdmin === 1 ?
                                userInfo?.user?.roleId !== 2 ? null
                                    :
                                    <Button text={"Set Target"} className={`!w-[150px]`} smallBtn onClick={() => handleTarget()} />
                                : null
                        }

                        {
                            userInfo?.user?.approvedByAdmin === null ?
                                userInfo?.user?.roleId !== 2 ? null
                                    :
                                    <>
                                        <Button text={"Decline"} className={`mr-4 ml-4 !w-[150px]`} smallBtn secondary onClick={() => setShowDeclinePopUp(true)} />
                                        <Button text={"Verify"} className={`!w-[150px]`} smallBtn onClick={() => verifyOpenModal()} />
                                    </>
                                : null
                        }
                    </div>
                </div>
                <div className='my-8'>
                    <UserInformation userInfo={userInfo?.user} slotsBooked={userInfo?.userInfo?.slotsBooked} />
                    <div className='w-100' style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginBottom: "20px", gap: "10px" }}>
                        {userInfo?.user?.is_profile_completed === 1 && userInfo?.user?.role?.name === "Mechanic" && (
                            <>
                                <Button
                                    text="Approve"
                                    StartIcon={Icons.tickIcon}
                                    smallBtn
                                    onClick={() => approveOpenModal()}
                                    disabled={!!userInfo?.user?.approvedByAdmin}
                                />
                                <Button
                                    text="Reject"
                                    StartIcon={Icons.delete}
                                    smallBtn
                                    onClick={() => setShowRejectModal(true)}
                                    disabled={userInfo?.user?.approvedByAdmin === 0}
                                />
                            </>
                        )}
                        <Button text={"Edit"} StartIcon={Icons.edit} smallBtn onClick={() => handleEditModal()} />
                    </div>
                    <div>
                    </div>
                    <PersonalInformation facilityPhotos={userInfo?.userInfo?.facilityPhotos?.documents} documents={userInfo?.userInfo?.identity?.documents}
                        businessInfo={userInfo?.userInfo?.businessInfo}
                        companyInfo={userInfo?.userInfo?.companyInfo}
                        contactInfo={userInfo?.userInfo?.contactInfo}
                        salesManagerDetails={userInfo?.user}
                    />
                    {/* <DealersTable /> */}
                    {userInfo?.userInfo?.rusers?.length > 0 ?
                        <AuthorizedUser userData={userInfo?.userInfo?.rusers} /> : null
                    }
                </div>
            </div>
            {isSalesManagerModal &&
                <ModalDropdown
                    isOpen={isSalesManagerModal}
                    closePopUp={() => setIsSalesManagerModal(false)}
                >
                    <div className={`${classes.reasonModalWrapper}`}
                        style={{ display: 'flex', flexDirection: 'column', height: !isDropdownOpen ? 'auto' : '450px' }}>

                        <div className={`${classes.modalHeader} flex items-center justify-between`}>
                            <div className={classes.modalTitle}>
                                {salesManagerAction === "VERIFY_RETAILER"
                                    ? "Select Sales Manager"
                                    : "Approve Mechanic"}
                            </div>

                            <div className={`${classes.modalCloser}`}>
                                <CloseIcon onClick={() => setIsSalesManagerModal(false)} />
                            </div>
                        </div>

                        <div className={classes.reasonFormContainer}
                            style={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
                            <FormProvider {...salesManagerForm}>
                                <form style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
                                    onSubmit={handleVerifySubmit(handleSalesManagerSubmit)}>

                                    <div className='border-[#D9D9D9] bg-white rounded-md border-[1px] my-3'>
                                        <Controller
                                            name="salesManager"
                                            control={salesManagerControl}
                                            rules={{ required: "Sales Manager is required" }}
                                            render={({ field }) => (
                                                <SearchableSelect
                                                    label="Sales Manager"
                                                    placeholder="Select sales manager"
                                                    options={salesManagers}
                                                    value={field.value || null}
                                                    handleChange={(val) => {
                                                        const selected = salesManagers.find(item => item.value === val);
                                                        field.onChange(selected);
                                                        // Close modal height if value is selected
                                                        if (selected) setIsDropdownOpen(false);
                                                    }}
                                                    required
                                                    borderTab={true}
                                                    onFocus={() => setIsDropdownOpen(true)}
                                                    onBlur={() => !field.value && setIsDropdownOpen(false)} // only shrink if no value
                                                />
                                            )}
                                        />

                                    </div>

                                    <Controller
                                        name="salesManager"
                                        control={salesManagerControl}
                                        render={({ fieldState }) =>
                                            fieldState.error ? (
                                                <p className={classes.errorText}>
                                                    {fieldState.error.message}
                                                </p>
                                            ) : null
                                        }
                                    />

                                    <div style={{ marginTop: 'auto', }} className='flex justify-end'>
                                        <Button text="Submit" className="w-full my-4" smallBtn type="submit" />
                                    </div>

                                </form>
                            </FormProvider>
                        </div>

                    </div>
                </ModalDropdown>
            }

            {showDeclinePopUp ?
                <ConfirmationModal
                    isOpen={showDeclinePopUp}
                    handleSuccess={declineUser}
                    closePopUp={handleClose}
                    warningText={'Confirmation'}
                    modalText={'Kindly provide the confirmation for declining the retailer’s request'}
                    confirmText={'Decline'}
                    cancelText={'Back'}
                    primaryBtnConfirm={false}
                />
                : null
            }
            {showReasonPopUp ?
                <ReasonModal isOpen={showReasonPopUp} closePopUp={handleReasonClose} userId={userId} />
                : null}
            {showVerifyPopUp ?
                <SuccessModal
                    isOpen={showVerifyPopUp}
                    closePopUp={handleVerifyClose}
                    successText={'Verified'}
                    modalText={'New retailer’s request has been successfully verified.'}
                />
                : null
            }
            {showTargetPopUP ? (
                <AddTarget
                    isOpen={showTargetPopUP}
                    closePopUp={closeTargetModal}
                    handleSuccessModal={handleSetTargetSuccess}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    id={getUserId()}
                    value={userInfo?.user?.membership_points || ''}
                />
            ) : null}
            {editResource ?
                <EditUserModal isOpen={editResource} closePopUp={handleCloseEditModal} activeTab={activeTab} resourceId={getUserId()} handleSuccessModal={getUserDetails} />
                : null}
            {showRejectModal ?
                <ModalDropdown isOpen={showRejectModal} closePopUp={() => setShowRejectModal(false)}>
                    <div className={`${classes.reasonModalWrapper}`}>
                        <div className={`${classes.modalHeader} flex items-center justify-between`}>
                            <div className={`${classes.modalTitle}`}>Add Reject Reason</div>
                            <div className={`${classes.modalCloser}`}>
                                <CloseIcon onClick={() => setShowRejectModal(false)} />
                            </div>
                        </div>
                        <div className={classes.reasonFormContainer}>
                            <FormProvider {...rejectForm}>
                                <form onSubmit={rejectHandleSubmit(onRejectSubmit)}>
                                    <div className={classes.formGroup}></div>

                                    <div className={classes.formField}>
                                        <InputBox
                                            label="Reason"
                                            className={`w-full ${classes.notesInput}`}
                                            name="reason"
                                            type="textarea"
                                            {...rejectRegister("reason", { required: true })}
                                            error={rejectErrors.reason}
                                            messages={{ required: "Reason is required" }}
                                        />
                                    </div>
                                    <div className="flex justify-end">
                                        <Button text="Submit" className="w-full my-4" smallBtn type="submit" />
                                    </div>
                                </form>
                            </FormProvider>
                        </div>
                    </div>
                </ModalDropdown>
                : null}
        </>
    )
}

export default UserDetails